import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initBasicReport,
  setBasicReport,
  setErrors
} from "redux/modules/basicReport";

// Component
import BasicReport from "components/ReportDetail/BasicReport";
// Utils
import history from "utils/history";

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initBasicReport: () => {
    dispatch(initBasicReport());
  },
  fetchBasicReport: () => {
    const { id } = ownProps.match.params;
    const params = new URLSearchParams(window.location.search);
    const attrItem = params.get('attr_item');
    if (attrItem) {
      api
        .get(`basic_report/${id}`, { attr_item_id: attrItem })
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setBasicReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    } else {
      api
        .get(`basic_report/${id}`)
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setBasicReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicReport);



// WEBPACK FOOTER //
// ./src/containers/ReportDetail/BasicReportContainer.js